import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export const INITIAL_STATE = {
  errors: [],
  warnings: [],
};

export default {
  state: () => ({ ...INITIAL_STATE }),
  getters: {
    errors: (state) => state.errors,
  },
  mutations: {
    add_error_queue(state, error) {
      state.errors.unshift(error);
    },
    delete_error_from_queue(state, idx) {
      state.errors.splice(idx, 1);
    },
  },
  actions: {
    add_error_queue({ commit }, payload) {
      const errStr = JSON.stringify(
        payload.error,
        Object.getOwnPropertyNames(payload.error)
      );
      const errorElement = {
        errorStr: errStr,
        customMessage: payload.message || "Erreur",
        errorStatus: payload.error?.response?.status || "",
        errorData: payload.error?.response?.data || "",
        errorMessage:
          payload.error?.response?.message || payload.error?.message || "",
      };
      commit("add_error_queue", errorElement);
      return "OK";
    },

    delete_error_from_queue({ commit }, idx) {
      commit("delete_error_from_queue", idx);
    },
  },
};
